import { styled } from "@mui/material/styles";

// Create styled components directly instead of a hook
export const StyledContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  backgroundColor: "#ffffff",
  maxWidth: 780,
  margin: "0 auto"
}));

export const StyledImage = styled("img")(({ theme }) => ({
  "@media (max-width: 800px)": {
    height: "80%",
    display: "block"
  },
  "@media (max-width: 620px)": {
    height: "55%"
  },
  "@media (max-width: 450px)": {
    height: "43%"
  }
}));
